import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const EyeOpen = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.900"],
  ...props
}) => (
  <Svg
    width={height}
    height={width}
    {...props}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
  >
    <Path
      d="M21.77 11.6c-.64-1.11-4.16-6.68-10.14-6.5-5.53.14-8.73 5-9.6 6.5a1 1 0 0 0 0 1c.63 1.09 4 6.5 9.89 6.5h.25c5.53-.14 8.74-5 9.6-6.5a1 1 0 0 0 0-1Zm-9.65 5.5c-4.31.1-7.12-3.59-8-5 1-1.61 3.61-4.9 7.61-5 4.29-.11 7.11 3.59 8 5-1.03 1.61-3.61 4.9-7.61 5Z"
      fill={color}
    />
    <Path
      d="M11.9 8.6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm0 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
      fill={color}
    />
  </Svg>
);

export default EyeOpen;
